import axiosClient from "@/libs/axiosClient";

export const ipValidate = (topic, val, groupName = "") => {
    return axiosClient.post(`/validate/ipvalidate`, {
        topic: topic,
        val: val,
        ...(groupName ? { groupName } : {}),
    });
};

export const luceneValidate = val => {
    return axiosClient.post(`/validate/lucenevalidate`, {
        val: val
    });
};

export const scrollValidate = val => {
    return axiosClient.post(`/validate/scrollvalidate`, {
        val: val
    });
};



// WEBPACK FOOTER //
// ./src/api/formValidate.js